import { defineMessages } from '@transcend-io/internationalization';

export const sessionManagerMessages = defineMessages(
  'privacy-center.containers.SessionManager.sessionManager',
  {
    label: {
      defaultMessage: 'Enter your email here to verify your identity',
      description:
        'Email modal title text when logging in using email magic link verification.',
    },
    email: {
      defaultMessage: 'Email Address',
      description:
        'Email address input label text when logging in using email magic link verification.',
    },
    submit: {
      defaultMessage: 'Send Email',
      description:
        'Button text when logging in using email magic link verification.',
    },
    loginFailed: {
      defaultMessage:
        'An unexpected error occurred while creating your session.',
      description:
        'Error message when logging in using email magic link verification.',
    },
    success: {
      defaultMessage: 'Email sent!',
      description:
        'Success message when logging in using email magic link verification.',
    },
    adblockError: {
      defaultMessage:
        'Browser extensions that block content or network requests such as Ghostery or PrivacyBadger ' +
        'can cause errors while submitting requests. If you are not able to submit the form ' +
        'after multiple attempts - please reach out to support to report the issue, including the browser ' +
        'and time at which you encountered the error.',
      description:
        'Error message when AdBlockers are detected while logging in using email magic link verification.',
    },
  },
);
